import { useHeaderTvl } from '@/app/components/Header/hooks/useHeaderTvl';
import { DesktopHeader } from '@/app/components/Header/layouts/DesktopHeader';
import { MobileHeader } from '@/app/components/Header/layouts/MobileHeader';
import VotingBanner from '@/app/components/VotingBanner/VotingBanner';

export const Header = () => {
  const { tvl, isLoading } = useHeaderTvl();

  return (
    <header className='relative z-20 bg-background'>
      <MobileHeader tvl={tvl} isLoading={isLoading} />
      <DesktopHeader tvl={tvl} isLoading={isLoading} />
      <VotingBanner />
    </header>
  );
};
